module.exports = __webpack_public_path__ + "img/cattunnel15.3ca6b08a.jpg";